import { Tooltip } from 'antd';
import CommonTable from '../Table/table';
import './style.scss';
import { RetweetOutlined, CheckCircleOutlined, ExclamationCircleOutlined, WarningOutlined } from '@ant-design/icons';
import DamagedIcon from '../../assets/images/damage_product.png';
import NotDamagedNotShootable from '../../assets/images/notDamaged_notShootable.png';
import outboundIcon from '../../assets/images/outbound_sku.svg';
import AuditPassedMark from '../AuditPassedMark';
import for_kids from '../../assets/images/gender_kids.png';
import for_female from '../../assets/images/gender_female.png';
import for_male from '../../assets/images/gender_male.png';
import for_unisex from '../../assets/images/gender_unisex.png';

const SymbolsDictionary = () => {
    const column = [
        {
            key: 'symbol',
            title: 'Symbol',
            width: '40%',
            align: 'center',
            render: (_, record) => {
                return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{record?.symbol || ''}</div>;
            },
        },
        {
            key: 'meaning',
            title: 'Meaning',
            align: 'left',
            render: (_, record) => {
                return record?.meaning || '';
            },
        },
    ];

    const data = [
        {
            symbol: (
                <div
                    className="rerunStatus"
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(249,245,245,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid red',
                    }}
                >
                    <Tooltip title={'Rerun Request'}>
                        <RetweetOutlined
                            style={{
                                color: 'red',
                            }}
                        />
                    </Tooltip>
                </div>
            ),
            meaning: 'Rerun Request; RawQC Complete ',
        },
        {
            symbol: (
                <div
                    className="rerunStatus"
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255,0,0)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid white',
                    }}
                >
                    <Tooltip title={'Rerun Request'}>
                        <RetweetOutlined
                            style={{
                                color: 'white',
                            }}
                        />
                    </Tooltip>
                </div>
            ),
            meaning: 'Rerun Request; RawQC Incomplete',
        },
        {
            symbol: (
                <div
                    className="damagedStatus"
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        borderRadius: '50%',
                        backgroundColor: 'rgb(6, 141, 169)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid white',
                    }}
                >
                    <Tooltip title={'Shootable and Damaged'}>
                        <img src={DamagedIcon} alt="outbound" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Damaged Product; Shootable',
        },
        {
            symbol: (
                <div
                    className="damagedStatus"
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        borderRadius: '50%',
                        backgroundColor: 'rgb(255, 146, 9)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid white',
                    }}
                >
                    <Tooltip title={'Not Shootable and Damaged'}>
                        <img src={DamagedIcon} alt="outbound" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Damaged Product; Not Shootable',
        },
        {
            symbol: (
                <div
                    className="damagedStatus"
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(249,245,245,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid rgb(61, 48, 162)',
                    }}
                >
                    <Tooltip title={'Not Shootable'}>
                        <img src={NotDamagedNotShootable} alt="outbound" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Not Shootable Product',
        },
        {
            symbol: (
                <div
                    className="outbound_status"
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0,255,0,0.8)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        border: '1px solid white',
                    }}
                >
                    <Tooltip title={'Outbound Complete!'}>
                        <img src={outboundIcon} alt="outbound" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Outbound Complete',
        },
        {
            symbol: <AuditPassedMark floating={false} />,
            meaning: 'Audit Passed',
        },
        {
            symbol: (
                <div
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        background: 'rgba(255,255,255,0.8)',
                        borderRadius: '50%',
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '1px 2px 9px -2px grey',
                    }}
                >
                    <Tooltip title={'Kids'}>
                        <img src={for_kids} alt="" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Gender(Kids)',
        },
        {
            symbol: (
                <div
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        background: 'rgba(255,255,255,0.8)',
                        borderRadius: '50%',
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '1px 2px 9px -2px grey',
                    }}
                >
                    <Tooltip title={'female'}>
                        <img src={for_female} alt="" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Gender(Female)',
        },
        {
            symbol: (
                <div
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        background: 'rgba(255,255,255,0.8)',
                        borderRadius: '50%',
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '1px 2px 9px -2px grey',
                    }}
                >
                    <Tooltip title={'male'}>
                        <img src={for_male} alt="" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Gender(Male)',
        },
        {
            symbol: (
                <div
                    style={{
                        height: '25px',
                        width: '25px',
                        zIndex: 3,
                        background: 'rgba(255,255,255,0.8)',
                        borderRadius: '50%',
                        padding: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        boxShadow: '1px 2px 9px -2px grey',
                    }}
                >
                    <Tooltip title={'unisex'}>
                        <img src={for_unisex} alt="" style={{ position: 'relative', objectFit: 'contain', height: '20px' }} />
                    </Tooltip>
                </div>
            ),
            meaning: 'Gender(Unisex)',
        },
        {
            symbol: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#00000055',
                        borderRadius: '13px 13px 13px 13px',
                        width: '25px',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            // height: '26px',
                            width: '25px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '13px 13px 0 0',
                            border: '1px solid white',
                            minHeight: '26px',
                        }}
                    >
                        <Tooltip title="Complete ">
                            <CheckCircleOutlined style={{ margin: 0, padding: 0, color: '#78D24B', fontSize: '1rem ' }} />
                        </Tooltip>
                    </div>
                </div>
            ),
            meaning: 'RawQC Complete ',
        },
        {
            symbol: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#00000055',
                        borderRadius: '13px 13px 13px 13px',
                        width: '25px',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            // height: '26px',
                            width: '25px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '13px 13px 0 0',
                            border: '1px solid white',
                            minHeight: '26px',
                        }}
                    >
                        <Tooltip title="Pending">
                            <ExclamationCircleOutlined style={{ margin: 0, padding: 0, color: 'red', fontSize: '1rem ' }} />
                        </Tooltip>
                    </div>
                </div>
            ),
            meaning: 'RawQC Pending',
        },
        {
            symbol: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: '#00000055',
                        borderRadius: '13px 13px 13px 13px',
                        width: '25px',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            // height: '26px',
                            width: '25px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '13px 13px 0 0',
                            border: '1px solid white',
                            minHeight: '26px',
                        }}
                    >
                        <Tooltip title="Partial">
                            <WarningOutlined style={{ margin: 0, padding: 0, color: '#DE6B32', fontSize: '1rem ', border: '1px solid red' }} />
                        </Tooltip>
                    </div>
                </div>
            ),
            meaning: 'Partial RawQC Complete',
        },
    ];

    return (
        <div className="symabols_main">
            <CommonTable columns={column} dataSource={data} pagination={false} bordered size="middle" />
        </div>
    );
};

export default SymbolsDictionary;
